export const supportNewEmailEditor = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const showOldTemplateEditor = searchParams.get('_newemail') === '0';

    if (showOldTemplateEditor) return !showOldTemplateEditor;

    return true;
};

export const isNewEmailTemplatesSupported = (): boolean => {
    return supportNewEmailEditor();
};
